import { useCallback, useEffect } from 'react';
import { POST_MESSAGES_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';

export const useElementHighlighter = ({ selector, onElementClick, highlightType, isHighlighting, regex }) => {
    const clearHighlights = useCallback(() => {
        window.parent.postMessage(
            {
                type: POST_MESSAGES_TYPES.UNHIGHLIGHT,
                selector,
                highlightType,
            },
            '*'
        );
    }, [selector, highlightType]);

    useEffect(() => {
        const handleElementClickMessage = event => {
            if (!event.data || event.data.type !== POST_MESSAGES_TYPES.CLICK) {
                return;
            }
            clearHighlights();
            onElementClick({
                eventName: event.data.text,
                path: event.data.path,
            });
        };

        window.addEventListener('message', handleElementClickMessage);

        if (isHighlighting) {
            window.parent.postMessage(
                {
                    type: POST_MESSAGES_TYPES.HIGHLIGHT,
                    selector,
                    highlightType,
                    regex: regex?.toString(),
                },
                '*'
            );
        } else {
            clearHighlights();
        }

        return () => {
            window.removeEventListener('message', handleElementClickMessage);
        };
    }, [isHighlighting, onElementClick, selector, highlightType, regex, clearHighlights]);

    return { clearHighlights };
};
